<template>
  <div>
    <router-view class="pub-content" />
    <air-footer class="w-100 fullpage" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AirFooter from '@/components/layout/Footer';

export default {
  components: {
    AirFooter,
  },
  computed: mapState(['settings']),
  name: 'PublicLayout',
  mounted() {
    this.detectViewPort(true);
    window.addEventListener('resize', this.detectViewPortListener);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectViewPortListener);
  },
  methods: {
    detectViewPortListener: function () {
      this.detectViewPort(false);
    },
    setViewPort: function (isMobileView = false, isTabletView = false) {
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMobileView',
        value: isMobileView,
      });
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isTabletView',
        value: isTabletView,
      });
    },
    detectViewPort: function (firstLoad = false) {
      const isMobile = this.settings['isMobileView'];
      const isTablet = this.settings['isTabletView'];
      const width = window.innerWidth;
      const state = {
        next: {
          mobile: width < 768,
          tablet: width < 992,
          desktop: !(width < 768) && !(width < 992),
        },
        prev: {
          mobile: isMobile,
          tablet: isTablet,
          desktop: !isMobile && !isTablet,
        },
      };
      // desktop
      // if (state.next.desktop && (state.next.desktop !== state.prev.desktop || firstLoad)) {
      //   this.setViewPort(false, false);
      // }
      // tablet & collapse menu
      if (state.next.tablet && !state.next.mobile && (state.next.tablet !== state.prev.tablet || firstLoad)) {
        this.setViewPort(false, true);
        this.$store.commit('CHANGE_SETTING', {
          setting: 'isMenuCollapsed',
          value: false,
        });
      }
      // mobile
      if (state.next.mobile && (state.next.mobile !== state.prev.mobile || firstLoad)) {
        this.setViewPort(true, false);
      }
    },
  },
};
</script>
<style lang="scss">
.pub-content {
  min-height: calc(100vh - 65px);
}
.fullpage {
  > div {
    max-width: 100%;
  }
}
</style>
